/* @license react-google-recaptcha-ultimate v1.2.2 */
import{generateGoogleReCaptchaHiddenBadgeStyles as e}from"./generateGoogleReCaptchaHiddenBadgeStyles.js";var t=function(){var t=document.createElement("style");t.innerHTML=e(),document.body.appendChild(t)};export{t as hideGoogleReCaptchaBadge};
//# sourceMappingURL=hideGoogleReCaptchaBadge.js.map
